import { render } from "./TipoDocumentoTextField.vue?vue&type=template&id=4fb07b2a&scoped=true"
import script from "./TipoDocumentoTextField.vue?vue&type=script&lang=js"
export * from "./TipoDocumentoTextField.vue?vue&type=script&lang=js"

import "./TipoDocumentoTextField.vue?vue&type=style&index=0&id=4fb07b2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb07b2a"]])

export default __exports__